define('Utility/UrlHelper',["jquery"], function ($) {

    var defaultHashDelimiter = "/";

    function createSetRegExp(urlParam) {
        /*
        [\?|&]                      Character set - Match any of these characters: [?|&]
        (urlParam=[^&]+|$)          Capturing parenthesis. (x) matches x and remembers the match.
            urlParam=               Explicit match
            [^&]+                   Negated character set. The + quantifier causes this item to be matched 1 or more times (greedy).
            |                       Or
            $                       Matches end of input.
        */
        return new RegExp("([\?|&])(" + urlParam + "=[^&#]+|$)", "gi");
    }

    function createGetRegExp(urlParam) {
        return new RegExp("[\?|&]" + urlParam + "=([^&#]+|$)", "gi");
    }


    function UrlHelper() {
        return undefined;
    }

    UrlHelper.prototype.getUrlParameters = function getUrlParameters(location, urlParam) {
        urlParam = decodeURIComponent(urlParam);
        var regExp = createGetRegExp(urlParam), url = location.href, results = [], value = regExp.exec(url);
        while (value) {
            results.push(value[1]);
            value = regExp.exec(url);
        }

        return results.map(decodeURIComponent);
    };

    UrlHelper.prototype.setUrlParameters = function setUrlParameter(location, urlParam, value) {
        value = encodeURIComponent(value);
        var url = location.href, regExp = createSetRegExp(urlParam);

        // Clear out all current instances of this param in the query string
        if (regExp.test(url)) {
            url = url.replace(regExp, "$1");
            // If query string was something like ?param=value&otherparam=othervalue and ew removed param=value then we would end up with ?&
            if (url.indexOf("?&") > -1) {
                url = url.replace("?&", "?");
            }
            if (url.indexOf("&&") > -1) {
                url = url.replace("&&", "&");
            }
        }

        if (value) {
            if (url.indexOf("?") < 0) {
                url += "?";
            } else if (new RegExp("[\?&]").test(url.slice(-1)) === false) {
                url += "&";
            }
            url += (urlParam + "=" + value);
        }

        if (window.location.pathname === location.pathname) {
            window.history.replaceState(null, document.title, url);
        }
        return url;
    };

    UrlHelper.prototype.getHashAsObject = function getHashAsObject(location, delimiter) {
        var hash = location.hash;
        return decodeURI(hash.slice(1))
            .split(delimiter || defaultHashDelimiter)
            .reduce(function (result, value) {
                value = value.split("=");
                if (value.length === 2) {
                    result[value[0]] = value[1];
                } else if (value.length === 1) {
                    result[value[0]] = undefined;
                }

                return result;
            }, {});
    };

    UrlHelper.prototype.getObjectAsHash = function getObjectAsHash(obj, delimiter) {
        var hash = "", del = delimiter || defaultHashDelimiter;
        $.each(obj, function (key, value) {
            hash = hash + key + "=" + value + del;
        });

        return encodeURI(hash.substring(0, hash.length - del.length)); // cut off trailing delimiter
    };

    UrlHelper.prototype.getHashValue = function getHashValue(location, paramName, delimiter) {
        return this.getHashAsObject(location, delimiter || defaultHashDelimiter)[paramName];
    };

    UrlHelper.prototype.setHashValue = function setHashValue(location, paramName, value, delimiter) {
        /**
         * location    - required, https://developer.mozilla.org/en-US/docs/Web/API/Location item
         * paramName   - required, parameter name
         * value       - required, parameter value
         * delimeter   - optional, character delimiting hash parameters
         */

        if (typeof (location.hash) !== "string") {
            throw new Error("location must implement Location");
        }

        var hash = this.getHashAsObject(location.hash, delimiter);
        if (!value) {
            delete hash[paramName];
        } else {
            hash[paramName] = value;
        }

        location.hash = this.getObjectAsHash(hash, delimiter || defaultHashDelimiter);
    };

    UrlHelper.prototype.appendHashValue = function appendHashValue(location, paramName, value, delimeter) {
        if (typeof (location.hash) !== "string") {
            throw new Error("location must implement Location");
        }

        var del = location.hash.length > 1 ? (delimeter || defaultHashDelimiter) : "";

        location.hash = location.hash + del + paramName + "=" + value;
    };

    return new UrlHelper(); // singleton
});
